export default __webpack_public_path__ + "static/media/gallery-wip-handle_08.ba08865a.jpg";